// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "chunks-css-min/" + ({"818":"news-js","2471":"about-scss","2762":"home-js","5452":"home_old","6441":"catalog-scss","6609":"faq","6946":"news","7594":"about","7624":"catalog","7962":"home","8381":"brands","8550":"brands-scss","8970":"faq-scss"}[chunkId] || chunkId) + ".css";
};